// Canonical list of rejection reasons. Used by:
// - Publisher reject modal (checkbox picker)
// - Advertiser "My campaigns" page (rejection banner)
// - The rejection email we'll eventually send
//
// Keep this list stable — codes end up persisted on submission rows.

export interface RejectionReason {
  code: string;
  label: string;
  advertiserText: string; // What the advertiser sees
}

export const REJECTION_REASONS: RejectionReason[] = [
  {
    code: 'prohibited_content',
    label: 'Prohibited content',
    advertiserText: 'Your ad contains content the publisher can\'t run (e.g. alcohol, tobacco, firearms, adult content).',
  },
  {
    code: 'misleading_claims',
    label: 'Misleading or unsubstantiated claims',
    advertiserText: 'Your ad makes claims that can\'t be substantiated, or that could mislead viewers.',
  },
  {
    code: 'quality_below_spec',
    label: 'Video quality below spec',
    advertiserText: 'Video quality is below our broadcast spec — check resolution, audio, and duration.',
  },
  {
    code: 'branding_unclear',
    label: 'Unclear branding or attribution',
    advertiserText: 'Your business branding or name isn\'t clearly identified in the ad.',
  },
  {
    code: 'broadcast_standards',
    label: "Doesn't meet broadcast standards",
    advertiserText: 'Your ad doesn\'t meet the publisher\'s broadcast standards (e.g. tone, language, pacing).',
  },
  {
    code: 'legal_compliance',
    label: 'Legal or regulatory issue',
    advertiserText: 'Your ad has a legal or regulatory compliance issue (disclosures, permissions, etc.).',
  },
  {
    code: 'broken_cta',
    label: 'Broken or invalid click-through URL',
    advertiserText: 'The click-through URL provided is broken or invalid.',
  },
  {
    code: 'other',
    label: 'Other (see note)',
    advertiserText: '',
  },
];

export const REJECTION_REASONS_BY_CODE: Record<string, RejectionReason> =
  Object.fromEntries(REJECTION_REASONS.map((r) => [r.code, r]));
